// src/pages/Landing.js
import React from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const WoMenPerfumeHeader = () => {
  const { t } = useTranslation();

  return (
    <main className="promotion-header" style={{ fontFamily: "'Hanuman', Arial, sans-serif" }}>
      <section className="shopping-header women-perfume-header d-flex justify-content-center align-items-center">
        <Container
          fluid
          className="d-flex justify-content-center align-items-center"
        >
          <div className="d-flex flex-column justify-content-center align-items-center">
            <span className="text-white fs-5 mt-5 mt-md-0">{t("Home / WomenPerfume")}</span>
            <h1 className="mt-4 text-white fs-custom">{t("All WomenPerfume")}</h1>
          </div>
        </Container>
      </section>
    </main>
  );
};

export default WoMenPerfumeHeader;
